<template>
  <div>
    <div class="text-center">
      <h1>Contact Subject</h1>
    </div>
    <div class="d-flex justify-content-end mx-5">
      <button
        @click="() => $router.push({ name: 'DetailContactSubject' })"
        class="btn btn-outline-primary"
      >
        Create
      </button>
    </div>
    <div class="text-center px-3">
      <ListContactSubjects />
    </div>
  </div>
</template>

<script>
import ListContactSubjects from "./ListContactSubjects.vue";
export default {
  components: {
    ListContactSubjects,
  },
};
</script>
